<form #packetAddForm="ngForm">
    <section class="tw-flex tw-flex-col tw-mb-1 tw-ml-3 tw-mt-12">
        <span class="p-float-label tw-w-[90%]">
            Visible
        </span>
    </section>
    <section class="tw-flex tw-flex-col tw-mb-6 tw-ml-3">
        <span class="p-float-label tw-w-[90%]">
            <p-selectButton [options]="addVisibleModes | keyvalue" [(ngModel)]="selectedPacket.add.visible"
                name="visible" optionLabel="value" optionValue="value"></p-selectButton>
        </span>
    </section>

    <section class="tw-flex tw-flex-col tw-mb-1 tw-ml-3">
        <span class="tw-w-full">
            Editable
        </span>
    </section>
    <section class="tw-flex tw-flex-col tw-mb-3 tw-ml-3">
        <span class="tw-w-full">
            <p-selectButton [options]="defaultSelectButtonOptions" [(ngModel)]="selectedPacket.add.editable"
                name="editable" optionLabel="label" optionValue="value"></p-selectButton>
        </span>
    </section>

</form>

<p-toolbar>
    <div class="tw-text-right tw-w-[95%] tw-mt-5 tw-row-span-4">
        <button [disabled]="!packetAddForm.dirty" pButton icon="fal fa-save" label="Save" (click)="saveChanges($event)"
            class="tw-mr-2"></button>
        <button [disabled]="!packetAddForm.dirty" pButton icon="fal fa-undo" label="Undo" (click)="resetForm()"
            class="p-button-warning p-button-outlined tw-mr-2"></button>
        <button pButton icon="fal fa-trash" label="Delete" (click)="deleteAdd($event)"
            class="p-button-warning p-button-outlined tw-mr-2"></button>
    </div>
</p-toolbar>

<p-confirmDialog key="ElynkAddDeleteDialog" appendTo="body" header="Delete Packet Add Configuration"
    message="Are you sure you want to delete this?" rejectButtonStyleClass="p-button-warning p-button-outlined">
</p-confirmDialog>
